import { BarChart3, Bell, BookOpenText, History, Link as LinkIcon, ShieldCheck } from "lucide-react";

export const navItems = [
  { to: "/dashboard", label: "Summary", icon: BarChart3, testId: "nav-summary-link" },
  { to: "/reflect", label: "Reflect", icon: BookOpenText, testId: "nav-reflect-link" },
  { to: "/history", label: "History", icon: History, testId: "nav-history-link" },
  { to: "/reminders", label: "Reminders", icon: Bell, testId: "nav-reminders-link" },
  { to: "/resources", label: "Resources", icon: LinkIcon, testId: "nav-resources-link" },
  { to: "/admin", label: "Admin", icon: ShieldCheck, testId: "nav-admin-link", adminOnly: true },
];